<template>
  <div class="payRecord">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="订单编号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.order_sn }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单明细" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payment_type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="下单时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.creationTime|dateformat("YYYY-MM-DD HH:mm") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center">
        <template slot-scope="scope">
          <span>￥{{ scope.row.order_price}}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.payment_time"
          >{{ scope.row.payment_time|dateformat("YYYY-MM-DD HH:mm") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付渠道" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payment_channel }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.payment_status}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column  label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            @click="toPay(scope.row)"
            type="text"
            size="small"
            v-if="scope.row.payment_status=='待支付'||scope.row.payment_status=='支付失败'"
          >去支付</el-button>
        </template>
      </el-table-column>-->
    </el-table>
    <div class="pagination" style="margin-top: 55px;text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount > 8"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { GetPersonalOrderRecord } from "@/api/admin/appraiser.js";
export default {
  data() {
    return {
      tableData: [],
      paging: {
        limit: 8,
        page: 1
      },
      totalCount: 0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      GetPersonalOrderRecord(Object.assign(this.paging)).then(data => {
        
        let list = data.data.result;
        this.totalCount = list.totalCount;
        if (list.items.length > 0) {
          this.tableData = list.items;
        }
      });
    },
    handleCurrentChange(page) {
      this.paging.page = page;
      this.getList();
    }
  },
  filters: {
    // status: i => {
    //   switch (i) {
    //     case 0:
    //       return "未完成";
    //     case 1:
    //       return "已完成";
    //   }
    // }
  }
};
</script>

<style lang="less" scoped>
</style>
